import React, { useState } from 'react'
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	Typography,
	Box,
	IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate'
import { apiBase } from '../../services/apiBase'
import { api } from '../../utils/api'
import { enqueueSnackbar } from 'notistack'

function CheckFreshStockModal({ open, onClose, type, productId, storeId }) {
	const [checkQuantity, setCheckQuantity] = useState('')
	const [checkPhotos, setCheckPhotos] = useState([])

	const handleSubmit = async (event) => {
		event.preventDefault()
		console.log(productId, storeId, checkQuantity)

		// Validate required fields first
		if (!productId || !storeId || !checkQuantity) {
			alert('Vui lòng điền đầy đủ thông tin bắt buộc')
			return
		}

		// Validate checkQuantity > 0
		if (parseInt(checkQuantity) <= 0) {
			alert('Số lượng phải lớn hơn 0')
			return
		}

		try {
			// Convert photos to base64
			const photoPromises = checkPhotos.map((photo) => {
				return new Promise((resolve, reject) => {
					const reader = new FileReader()
					reader.onload = () => resolve(reader.result)
					reader.onerror = reject
					reader.readAsDataURL(photo)
				})
			})

			const base64Photos = await Promise.all(photoPromises)

			// Send request
			const requestData = {
				value: parseInt(checkQuantity),
				productId: productId,
				storeId: storeId,
				images: base64Photos,
			}
			await apiBase.post(api.POST_CHECK_STOCK, requestData)

			enqueueSnackbar('Kiểm kho thành công')
			// Reset form
			setCheckQuantity('')
			setCheckPhotos([])
			onClose()
		} catch (error) {
			console.error('Error:', error)
			alert(error?.response?.data?.message || 'Có lỗi xảy ra')
		}
	}

	return (
		<Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
			<DialogTitle
				sx={{
					pb: 1,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<Typography variant='h6'>Kiểm kho {type}</Typography>
				<IconButton onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent sx={{ pt: 2 }}>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 2,
						mb: 3,
					}}>
					<TextField
						fullWidth
						placeholder='Số lượng thực tế (phần)'
						value={checkQuantity}
						onChange={(e) => setCheckQuantity(e.target.value)}
						sx={{
							'& .MuiOutlinedInput-root': {
								borderRadius: 3,
							},
						}}
					/>
					<label htmlFor='check-photos'>
						<Box
							sx={{
								width: 40,
								height: 40,
								border: '2px dashed #4caf50',
								borderRadius: 2,
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								cursor: 'pointer',
								flexShrink: 0,
							}}>
							<AddPhotoAlternateIcon sx={{ color: '#4caf50', fontSize: 24 }} />
						</Box>
					</label>
					<input
						id='check-photos'
						type='file'
						accept='image/*'
						multiple
						hidden
						onChange={(e) => {
							if (e.target.files) {
								setCheckPhotos((prev) => [...prev, ...Array.from(e.target.files)])
							}
						}}
					/>
				</Box>

				{checkPhotos.length > 0 && (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 2,
							flexWrap: 'wrap',
						}}>
						{checkPhotos.map((photo, index) => (
							<Box
								key={index}
								sx={{
									position: 'relative',
									width: 100,
									height: 100,
								}}>
								<img
									src={URL.createObjectURL(photo)}
									alt={`Check ${index + 1}`}
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'cover',
										borderRadius: 8,
									}}
								/>
								<IconButton
									size='small'
									sx={{
										position: 'absolute',
										top: -8,
										right: -8,
										backgroundColor: '#fff',
										border: '1px solid #ddd',
										'&:hover': { backgroundColor: '#fff' },
									}}
									onClick={() => {
										setCheckPhotos((photos) => photos.filter((_, i) => i !== index))
									}}>
									<CloseIcon fontSize='small' color='error' />
								</IconButton>
							</Box>
						))}
					</Box>
				)}
			</DialogContent>

			<DialogActions sx={{ p: 2, gap: 2 }}>
				<Button
					variant='contained'
					fullWidth
					sx={{
						borderRadius: 8,
						py: 1,
						backgroundColor: '#4caf50',
						'&:hover': { backgroundColor: '#388e3c' },
					}}
					onClick={handleSubmit}>
					Xác nhận
				</Button>
				<Button
					variant='contained'
					fullWidth
					sx={{
						borderRadius: 8,
						py: 1,
						backgroundColor: '#ff5252',
						'&:hover': { backgroundColor: '#d32f2f' },
					}}
					onClick={onClose}>
					Hủy
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default CheckFreshStockModal
